<template>
    <v-container fluid class="white elevation-4 pt-0 pb-0">
        <main-app-bar :title="$router.currentRoute.meta.title">
            <template v-slot:buttons>
                <v-btn color="primary" :disabled='initialLoading' @click="openAddDialog">
                    <v-icon left>mdi-plus</v-icon> Add Invoice
                </v-btn>
            </template>
        </main-app-bar>
        <v-row class="d-block grey lighten-4">
            <v-container>
                <v-row>
                    <v-col cols="auto" class="py-0">
                        <v-btn color="black lighten-2" text class="btn-filter" :disabled='initialLoading' @click="filterOpened = !filterOpened">
                            Filters
                            <v-icon style="fill: #000;" right>$filter</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
            <v-expand-transition>
                <v-card v-show="filterOpened" elevation="0" class="px-5 transparent" height="auto" style=" width: 100%;" :disabled="getInvoicesLoading">
                    <v-row class="align-start">
                        <v-col cols="6">
                            <v-text-field
                                label="Invoice"
                                placeholder="Invoice name"
                                type="text"
                                autocomplete="off"
                                v-model="invoiceNameDebounce"
                                outlined
                                dense
                                clearable
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                :return-value.sync="dateRangeAlias"
                                transition="scale-transition"
                                offset-y
                                max-width="290"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        :value="dateRangeAlias && dateRangeAlias.length ? Date.formatDate(dateRangeAlias) : []"
                                        placeholder="Select Date Range"
                                        label="Date range"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        outlined
                                        dense
                                        v-on="on"
                                        clearable
                                        @click:clear='dateRangeAlias = [];filterOptions.DateFrom = "";filterOptions.DateTo = "";'
                                    />
                                </template>
                                <v-date-picker v-model="dateRangeAlias" range>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="dateAliasChanges(dateRangeAlias)">OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-card>
            </v-expand-transition>
        </v-row>
        <v-row class="d-block lighten-4 align-center">
            <v-data-table
                :loading="getInvoicesLoading"
                :headers="headers"
                :items="invoicesItems"
                :options.sync="options"
                :items-per-page="options.itemsPerPage"
                :server-items-length="metaData.totalElements"
                :footer-props="{
                        'show-current-page': true,
                        'show-first-last-page': true,
                        'items-per-page-options': [10,20,50]
                    }"
            >
                <template v-slot:body="{ items }">
                    <template v-if="items.length">
                        <tr :key="item.id" v-for="item of items" style='cursor: pointer;' @click='openCurrentInvoice(item)'>
                            <template>
                                <td>
                                    {{ item.name.toUpperCase() }}
                                </td>
                                <td>
                                    {{ Date.formatDate([item.date]) }}
                                </td>
                                <td>
                                    {{ item.uploadedBy }}
                                </td>
                                <td>
                                    {{ item.updatedBy }}
                                </td>
                                <td align='right'>
                                    <DeleteInvoiceButton :invoiceData='item' @updateInvoicesList='getInvoices'/>
                                </td>
                            </template>
                        </tr>
                    </template>
                    <template v-else>
                        <tr>
                            <td :colspan="headers.length">
                                <div class="text-center grey--text py-4">No data available</div>
                            </td>
                        </tr>
                    </template>
                </template>
            </v-data-table>
        </v-row>
        <v-dialog v-model="addDialog" width="350" @click:outside="closeAddDialog">
            <v-card>
                <v-card-title  class="body-1 grey lighten-3 d-flex justify-space-between">
                    New invoice
                </v-card-title>
                <v-card-text class="pa-5">
                    <v-menu
                        v-model="newInvoiceDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                :value="Date.formatDate([newInvoiceDate])"
                                label="Invoice date"
                                prepend-icon="mdi-calendar"
                                readonly
                                outlined
                                dense
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker first-day-of-week="1" v-model="newInvoiceDate" @input="newInvoiceDateMenu = false"></v-date-picker>
                    </v-menu>
                    <div class="py-5">
                        <v-btn v-if="!newInvoiceFiles.length" block outlined @click="handleFileSelection">select file</v-btn>
                        <v-chip v-else v-for='(file, index) in newInvoiceFiles' :key='`${file.name}-${index}`' class='mr-1 mb-1' close close-icon="mdi-delete" label @click:close="newInvoiceFiles.splice(index, 1)">
                            <div class="text-truncate">{{ file.name }}</div>
                        </v-chip>
                    </div>
                    <input
                        ref="uploader"
                        class="d-none"
                        type="file"
                        accept=".pdf, .doc, .docx"
                        multiple
                        @change="onFileChanged($event)"
                    />
                    <v-row>
                        <v-col>
                            <v-btn block :disabled="uploadLoading" @click="closeAddDialog">cancel</v-btn>
                        </v-col>
                        <v-col>
                            <v-btn block color="primary" :loading="uploadLoading" :disabled="uploadLoading || !newInvoiceDate || !newInvoiceFiles.length" @click="uploadFile">save</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="invoiceDialog" width="1024" @click:outside="closeInvoiceDialog">
            <v-card>
                <v-card-title class="py-3 body-1 grey lighten-3 d-flex justify-space-between font-weight-regular">
                    {{selectedInvoice && selectedInvoice.name || '--/--'}}
                    <template v-if='selectedInvoice'>
                        <v-menu
                            v-model="selectedInvoiceDateMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    :value="Date.formatDate([selectedInvoiceDate])"
                                    label="Invoice date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    outlined
                                    dense
                                    v-on="on"
                                    style="max-width: 235px;"
                                    class='ml-auto mb-n1'
                                ></v-text-field>
                            </template>
                            <v-date-picker first-day-of-week="1" v-model="selectedInvoiceDate" @input="selectedInvoiceDateMenu = false"></v-date-picker>
                        </v-menu>
                        <v-btn color="primary" class="ml-3" :loading="updateLoading" :disabled="updateLoading || !selectedInvoiceDate || isEqualDate" @click="initUpdate">update</v-btn>
                        <v-btn color="info" class="ml-3" target='_blank' :href='selectedInvoice.downloadLink' :disabled='selectedInvoiceLoading || updateLoading'>download</v-btn>
                    </template>
                    <v-btn icon @click="closeInvoiceDialog" class="ml-5">
                        <v-icon>$close</v-icon>
                    </v-btn>
                </v-card-title>
                <div v-if='selectedInvoiceLoading' style='height: 208px;position: relative'>
                    <v-progress-linear absolute height="4" indeterminate color="primary"/>
                </div>
                <v-card-text v-if='selectedInvoice && !selectedInvoiceLoading' class="pa-5">
                    <SimpleFilePreview :fileData="selectedInvoice"/>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="5000" :top="true" class="text-center justify-center">
            <div class="text-center flex-grow-1">{{ snackbarText }}</div>
        </v-snackbar>
    </v-container>
</template>

<script>
    import MainAppBar from '@/components/MainAppBar.vue'
    import { mapActions, mapGetters } from 'vuex'
    import DeleteInvoiceButton from '@/views/accounting/components/DeleteInvoiceButton.vue'
    import SimpleFilePreview from '@/views/accounting/SimpleFilePreview.vue'

    export default {
        components: {
            SimpleFilePreview,
            DeleteInvoiceButton,
            MainAppBar
        },
        data () {
            return {
                metaData: {},
                debounceTimeout: null,
                menu: false,
                snackbar: false,
                snackbarText: '',
                snackbarColor: 'error',
                initialLoading: true,
                filterOpened: false,
                addDialog: false,
                newInvoiceFiles: [],
                newInvoiceDate: '',
                newInvoiceDateMenu: false,
                uploadLoading: false,
                dateRangeAlias: [],
                invoiceNameDebounce: '',
                filterOptions: {
                    InvoiceName: '',
                    DateFrom: '',
                    DateTo: ''
                },
                options: {
                    itemsPerPage: 10,
                    page: 1,
                    sortBy: ['date'],
                    sortDesc: [true],
                    mustSort: false,
                    multiSort: false
                },
                getInvoicesLoading: false,
                invoicesItems: [],
                selectedInvoiceLoading: false,
                invoiceDialog: false,
                selectedInvoice: null,
                selectedInvoiceDate: '',
                selectedInvoiceDateMenu: false,
                updateLoading: false
            }
        },
        computed: {
            ...mapGetters(['getUserActiveGroup', 'getUserActiveClinic']),
            headers () {
                const headers = [
                    {
                        text: 'Name',
                        align: 'left',
                        sortable: true,
                        value: 'name'
                    },
                    {
                        text: 'Date',
                        align: 'left',
                        sortable: true,
                        value: 'date'
                    },
                    {
                        text: 'Uploaded By',
                        align: 'left',
                        sortable: true,
                        value: 'uploadedBy'
                    },
                    {
                        text: 'Updated By',
                        align: 'left',
                        sortable: true,
                        value: 'updatedBy'
                    },
                    {
                        text: '',
                        align: 'left',
                        sortable: false,
                        value: '',
                        width: 70
                    }
                ]
                return headers
            },
            isEqualDate () {
                const dateTimeWithZone = new Date(this.selectedInvoiceDate)
                const simpleDate = new Date(this.selectedInvoice.date)

                const normalizedDateWithZone = new Date(dateTimeWithZone.getFullYear(), dateTimeWithZone.getMonth(), dateTimeWithZone.getDate())
                const normalizedSimpleDate = new Date(simpleDate.getFullYear(), simpleDate.getMonth(), simpleDate.getDate())

                return normalizedDateWithZone.getTime() === normalizedSimpleDate.getTime()
            },
            groupId () {
                return this.getUserActiveGroup
            },
            clinicId () {
                return this.getUserActiveClinic
            }
        },
        watch: {
            options: {
                handler (newValue, oldValue) {
                    if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
                        this.getInvoices()
                    }
                },
                deep: true
            },
            filterOptions: {
                handler () {
                    this.options.page = 1
                    this.getInvoices()
                },
                deep: true
            },
            invoiceNameDebounce (newValue) {
                this.debounce(() => {
                    this.filterOptions.InvoiceName = newValue
                }, 500)
            },
            groupId () {
                this.options.page = 1
                this.getInvoices()
            },
            clinicId () {
                this.options.page = 1
                this.getInvoices()
            }
        },
        methods: {
            ...mapActions(['fetchInvoices', 'fetchSingleInvoice', 'createInvoice', 'updateInvoice', 'uploadDocuments']),
            debounce (callback, delay) {
                clearTimeout(this.debounceTimeout)
                this.debounceTimeout = setTimeout(callback, delay)
            },
            dateAliasChanges (date) {
                this.$refs.menu.save(date)
                if (this.dateRangeAlias.length === 2) {
                    this.dateRangeAlias = this.dateRangeAlias.sort((a, b) => new Date(a) - new Date(b))
                    this.filterOptions.DateFrom = this.dateRangeAlias[0]
                    this.filterOptions.DateTo = this.dateRangeAlias[1]
                }
            },
            openAddDialog () {
                this.addDialog = true
            },
            closeAddDialog () {
                this.addDialog = false
                this.newInvoiceDate = ''
                this.newInvoiceFiles = []
            },
            handleFileSelection () {
                this.$refs.uploader.click()
            },
            onFileChanged (event) {
                if (event.target.files.length > 0) {
                    const localFiles = []
                    Array.from(event.target.files).forEach(file => {
                        localFiles.push({
                            name: file.name,
                            file: file
                        })
                    })
                    this.newInvoiceFiles = localFiles
                }
                event.target.value = ''
            },
            openInvoiceDialog () {
                this.invoiceDialog = true
            },
            closeInvoiceDialog () {
                this.selectedInvoiceDate = ''
                this.selectedInvoiceDateMenu = false
                this.invoiceDialog = false
                this.selectedInvoice = null
            },
            async openCurrentInvoice (invoiceData) {
                try {
                    this.selectedInvoiceLoading = true
                    this.openInvoiceDialog()
                    const newInvoiceData = await this.fetchSingleInvoice(invoiceData.id)
                    this.selectedInvoiceDate = invoiceData.date.split('T')[0]
                    this.selectedInvoice = {
                        id: invoiceData.id,
                        date: newInvoiceData.data.date,
                        name: newInvoiceData.data.name,
                        link: newInvoiceData.data.attachment.link,
                        downloadLink: newInvoiceData.data.attachment.downloadLink,
                        extension: newInvoiceData.data.attachment.extension
                    }
                    this.selectedInvoiceLoading = false
                } catch (e) {
                    this.selectedInvoiceLoading = false
                }
            },
            async uploadFile () {
                const formData = new FormData()
                const createInvoiceQuery = {}
                this.newInvoiceFiles.forEach((item) => {
                    formData.append('Files', item.file)
                })
                createInvoiceQuery.groupId = this.groupId
                createInvoiceQuery.clinicId = this.clinicId
                createInvoiceQuery.date = this.newInvoiceDate
                try {
                    this.uploadLoading = true
                    const uploadData = await this.uploadDocuments(formData)
                    createInvoiceQuery.documentIds = uploadData.data.documentIds
                    await this.createInvoice(createInvoiceQuery)
                    await this.getInvoices()
                    this.uploadLoading = false
                    this.closeAddDialog()
                    this.snackbarColor = 'success'
                    this.snackbarText = 'File successfully uploaded'
                    this.snackbar = true
                } catch (e) {
                    this.uploadLoading = false
                    this.snackbarColor = 'error'
                    this.snackbarText = 'File uploading failed'
                    this.snackbar = true
                }
            },
            invoicesParams () {
                const localFilterOptions = {}
                this.filterOptions.InvoiceName && (localFilterOptions.InvoiceName = this.filterOptions.InvoiceName)
                if (this.filterOptions.DateFrom && this.filterOptions.DateTo) {
                    localFilterOptions.DateFrom = this.filterOptions.DateFrom
                    localFilterOptions.DateTo = this.filterOptions.DateTo
                }
                const queryData = {
                    groupId: this.groupId,
                    clinicId: this.clinicId,
                    PageSize: this.options.itemsPerPage,
                    PageNumber: this.options.page,
                    sortField: this.options.sortBy[0] || 'id',
                    sortOrder: this.options.sortDesc[0] ? 'DESC' : 'ASC',
                    ...localFilterOptions
                }
                return queryData
            },
            async getInvoices () {
                try {
                    this.getInvoicesLoading = true
                    const invoicesData = await this.fetchInvoices(this.invoicesParams())
                    this.metaData = invoicesData.data.metadata
                    this.invoicesItems = invoicesData.data.items || []
                    this.getInvoicesLoading = false
                    this.initialLoading = false
                } catch (e) {
                    this.getInvoicesLoading = false
                    this.initialLoading = false
                    this.snackbarColor = 'error'
                    this.snackbarText = 'Loading failed'
                    this.snackbar = true
                }
            },
            async initUpdate () {
                const queryData = {}
                queryData.invoiceId = this.selectedInvoice.id
                queryData.date = this.selectedInvoiceDate
                try {
                    this.updateLoading = true
                    await this.updateInvoice(queryData)
                    await this.getInvoices()
                    this.closeInvoiceDialog()
                    this.updateLoading = false
                    this.snackbarColor = 'success'
                    this.snackbarText = 'Invoice successfully updated'
                    this.snackbar = true
                } catch (e) {
                    this.updateLoading = false
                    this.snackbarColor = 'error'
                    this.snackbarText = 'Invoice update failed'
                    this.snackbar = true
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .history-table::v-deep {
        > .v-data-table__wrapper > table {
            background: #f5f5f5;

            > thead {
                > tr {
                    > th {
                        background: #f5f5f5;
                    }
                }
            }

            > tbody {
                > tr {
                    > td {
                        background: #f5f5f5;
                    }
                }
            }
        }
    }
</style>
